// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=pro` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular-cli.json`.
export const environment = {
  production: true,
  isMock: false,
  baseUrl: 'https://api-tlc.rongxiangjiankang.com/',
  qrCodeUrl: 'http://pub.rongxiangjiankang.com',
  aliyun: {
    bucket: 'tailelive',
    urlStr: 'https://tailelive.oss-cn-shanghai.aliyuncs.com/'
  }
};


// WEBPACK FOOTER //
// D:/taile-operate/BLACK-WIDOW/ng-src/environments/environment.ts